import { render, staticRenderFns } from "./RulesTable.vue?vue&type=template&id=7680a5f8&scoped=true&"
import script from "./RulesTable.vue?vue&type=script&lang=js&"
export * from "./RulesTable.vue?vue&type=script&lang=js&"
import style0 from "./RulesTable.vue?vue&type=style&index=0&id=7680a5f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7680a5f8",
  null
  
)

export default component.exports